// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bay_a bgu_i bgu_q bgu_j"};